import { Alert, Button, Stack, Typography } from '@mui/material';
import { CenteredFormPage } from 'components/CenteredFormPage';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'stores/RootStore';

const ConfirmEmailPage = observer(() => {
  const { routeStore, confirmEmailStore } = useRootStore();
  const { goHome } = routeStore;
  const { status, message, resendEmail } = confirmEmailStore;

  return (
    <CenteredFormPage aria-label="confirm email page">
      <form autoComplete="off">
        <Stack spacing={4}>
          <Typography variant="h5" textAlign="center">
            <strong>Confirm Email Address</strong>
          </Typography>
          {message && (
            <Alert
              aria-label="form-error"
              severity={status === 'checkTokenError' || status === 'resendEmailError' ? 'error' : 'success'}
            >
              {message}
            </Alert>
          )}
          {status === 'checkTokenSuccess' ? (
            <Button variant="contained" disableElevation style={{ height: 56 }} onClick={() => goHome()}>
              Continue
            </Button>
          ) : (
            <Button
              variant="contained"
              disableElevation
              style={{ height: 56 }}
              disabled={status === 'resendEmailLoading' || status === 'checkTokenLoading'}
              onClick={() => resendEmail()}
            >
              Re-Send Email
            </Button>
          )}
        </Stack>
      </form>
    </CenteredFormPage>
  );
});

export { ConfirmEmailPage };
